@import 'apps/webcomponents/src/assets/style-helpers.scss';

.wrapper {
  flex-direction: column;
  background: var(--white-layout-301-level-0-elevation);
}

gz-side-menu {
  z-index: 9999;
}

gz-tab-group {
  --tab-header-padding-left: 28px;
}

.page__header {
  display: flex;
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
  align-items: center;
  gap: calc(var(--spacer) * 2);
}

.header {
  width: 100%;
  display: flex;
  justify-content: end;
  padding: 4px calc(3 * var(--spacer));
}

.company-selector {
  width: auto;
  height: 35px;
}

.configuration-profiles-tab {
  padding: calc(2 * var(--spacer)) 0 0;
}

.configuration-profiles-details-panel {
  z-index: 1000;
}

gz-dialog {
  padding: calc(3 * var(--spacer));
}

@media screen and (max-height: 768px) {
  :host {
    --gz-enum-max-height: 200px;
  }
}

@media screen and (max-height: 720px) {
  :host {
    --gz-enum-max-height: 141px;
  }
}
